(ns frontend.test.avatar.view
  (:require
   [ui.components.avatar.view :as avatar]))

(defn view
  []
  [:div
   {:class "tw2 tw2-p-4 tw2-flex tw2-flex-col tw2-gap-6 tw2-bg-bg-primary tw2-min-h-screen"}
   [:div
    {:class "tw2-flex tw2-flex-col tw2-gap-2"}
    [:h2
     {:class "tw2-text-lg tw2-font-semibold tw2-text-primary"}
     "Avatar"]
    [:p
     {:class "tw2-text-sm tw2-text-secondary"}
     "Displays a profile image or fallback content. Supports default, hover and pressed states."]]

   [:div
    {:class "tw2-flex tw2-flex-col tw2-gap-2"}
    [:h3
     {:class "tw2-text-base tw2-font-semibold tw2-text-primary"}
     "Action States"]
    [:p
     {:class "tw2-text-sm tw2-text-secondary"}
     "Storybook preview states. These are controlled with :storybook {:action-state ...}."]
    [:div
     {:class "tw2-flex tw2-flex-wrap tw2-gap-6 tw2-items-start"}
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:storybook {:action-state :default
                                :interactive? false}}
       "JD"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Default"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:storybook {:action-state :hover
                                :interactive? false}}
       "JD"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Hover"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:storybook {:action-state :pressed
                                :interactive? false}}
       "JD"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Pressed"]]]]

   [:div
    {:class "tw2-flex tw2-flex-col tw2-gap-2"}
    [:h3
     {:class "tw2-text-base tw2-font-semibold tw2-text-primary"}
     "Sizes"]
    [:p
     {:class "tw2-text-sm tw2-text-secondary"}
     "Size variants using top-level :class overrides while keeping the same Avatar behavior."]
    [:div
     {:class "tw2-flex tw2-flex-wrap tw2-gap-6 tw2-items-end"}
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:class "tw2-w-5 tw2-h-5 tw2-text-[10px]"}
       "XS"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "XS"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:class "tw2-w-6 tw2-h-6 tw2-text-xs"}
       "SM"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "SM"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:class "tw2-w-8 tw2-h-8 tw2-text-sm"}
       "MD"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "MD"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:class "tw2-w-10 tw2-h-10 tw2-text-sm"}
       "LG"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "LG"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:class "tw2-w-12 tw2-h-12 tw2-text-base"}
       "XL"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "XL"]]]]

   [:div
    {:class "tw2-flex tw2-flex-col tw2-gap-2"}
    [:h3
     {:class "tw2-text-base tw2-font-semibold tw2-text-primary"}
     "Image And Fallback"]
   [:p
    {:class "tw2-text-sm tw2-text-secondary"}
    "When :src is valid an image is shown. On image error, fallback content is rendered."]
   [:div
     {:class "tw2-flex tw2-flex-wrap tw2-gap-6 tw2-items-start"}
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:src "https://i.pravatar.cc/40?img=12"
                    :alt "Profile image"}
       "JD"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Valid Image"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:src "https://invalid.example.com/not-found.png"
                    :alt "Broken image fallback"}
       "ER"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Broken Image Fallback"]]]
    [:p
     {:class "tw2-text-sm tw2-text-secondary"}
     "Image sizes using top-level :class overrides."]
    [:div
     {:class "tw2-flex tw2-flex-wrap tw2-gap-6 tw2-items-end"}
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:src "https://i.pravatar.cc/40?img=12"
                    :alt "Avatar XS"
                    :class "tw2-w-5 tw2-h-5"}
       "XS"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Image XS"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:src "https://i.pravatar.cc/40?img=12"
                    :alt "Avatar SM"
                    :class "tw2-w-6 tw2-h-6"}
       "SM"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Image SM"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:src "https://i.pravatar.cc/40?img=12"
                    :alt "Avatar MD"
                    :class "tw2-w-8 tw2-h-8"}
       "MD"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Image MD"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:src "https://i.pravatar.cc/40?img=12"
                    :alt "Avatar LG"
                    :class "tw2-w-10 tw2-h-10"}
       "LG"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Image LG"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:src "https://i.pravatar.cc/40?img=12"
                    :alt "Avatar XL"
                    :class "tw2-w-12 tw2-h-12"}
       "XL"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Image XL"]]]]

   [:div
    {:class "tw2-flex tw2-flex-col tw2-gap-2"}
    [:h3
     {:class "tw2-text-base tw2-font-semibold tw2-text-primary"}
     "Interactivity"]
    [:p
     {:class "tw2-text-sm tw2-text-secondary"}
     ":storybook {:interactive? true} forces interactive visuals. :on-click makes the avatar clickable and adds button semantics."]
    [:div
     {:class "tw2-flex tw2-flex-wrap tw2-gap-6 tw2-items-start"}
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:storybook {:interactive? true}}
       "IA"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Visual Interactivity"]]
     [:div
      {:class "tw2-flex tw2-flex-col tw2-items-center tw2-gap-2"}
      [avatar/view {:on-click (fn [_]
                                (js/console.log "Avatar clicked"))}
       "CL"]
      [:span
       {:class "tw2-text-xs tw2-text-secondary"}
       "Clickable Avatar"]]]]])
